var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrap"},[_c('div',{staticClass:"modal-content"},[(_vm.showClose)?_c('img',{staticClass:"close-icon",attrs:{"src":require("@/assets/images/order-manage/ic_order_off.png")},on:{"click":_vm.onCloseClick}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }